// extracted by mini-css-extract-plugin
export default {"premiumJobs":"PremiumJobs_premiumJobs__Ojs7k","slideIn":"PremiumJobs_slideIn__CcqkM"};